import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Main from "@/views/main.vue";
import Login from "@/views/login.vue";
import MemberList from "@/views/member/memberList.vue";
import AdminList from "@/views/member/adminList.vue";
import LetterAgreeList from "@/views/member/letterAgreeList.vue";

import ActionGroupList from "@/views/member/action/groupList.vue";
import ActionGroupDetail from "@/views/member/action/groupDetail.vue";
import ActionStateList from "@/views/member/action/stateList.vue";
import ActionStateDetail from "@/views/member/action/stateDetail.vue";

import MainPage from "@/views/site/mainPage.vue";
import ReportList from "@/views/site/reportList.vue";
import ActivityList from "@/views/site/activityList.vue";
import ActivityManageList from "@/views/site/activityManageList.vue";
import ActivityStateList from "@/views/site/activityStateList.vue";

import EventList from "@/views/site/eventList.vue";
import NewsList from "@/views/site/newsList.vue";
import ArchiveList from "@/views/site/archiveList.vue";
import QnaList from "@/views/site/qnaList.vue";

import Statistics from "@/views/statistics/statistics.vue";

import { userStore } from "@/BaseComponent";

const routes: Array<RouteRecordRaw> = [
    { path: "/", name: "Main", component: Main },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: { requiresAuth: true },
    },
    { path: "/memberList", name: "memberList", component: MemberList, meta: { requiresAuth: true } },
    { path: "/adminList", name: "adminList", component: AdminList, meta: { requiresAuth: true } },
    { path: "/letterAgreeList", name: "letterAgreeList", component: LetterAgreeList, meta: { requiresAuth: true } },
    { path: "/action/group", name: "actionGroupList", component: ActionGroupList, meta: { requiresAuth: true } },
    { path: "/action/group/:idx", name: "actionGroupDetail", component: ActionGroupDetail, meta: { requiresAuth: true } },
    { path: "/action/:groupidx/state", name: "actionStateList", component: ActionStateList, meta: { requiresAuth: true } },
    { path: "/action/:groupidx/state/:idx", name: "actionStateDetail", component: ActionStateDetail, meta: { requiresAuth: true } },

    { path: "/mainPage", name: "mainPage", component: MainPage, meta: { requiresAuth: true } },
    { path: "/reportList", name: "reportList", component: ReportList, meta: { requiresAuth: true } },
    { path: "/activityList", name: "activityList", component: ActivityList, meta: { requiresAuth: true } },
    { path: "/activityManageList", name: "activityManageList", component: ActivityManageList, meta: { requiresAuth: true } },
    // { path: "/activityStateList", name: "activityStateList", component: ActivityStateList, meta: { requiresAuth: true } },

    { path: "/eventList", name: "eventList", component: EventList, meta: { requiresAuth: true } },
    { path: "/newsList", name: "newsList", component: NewsList, meta: { requiresAuth: true } },
    { path: "/archiveList", name: "archiveList", component: ArchiveList, meta: { requiresAuth: true } },
    { path: "/qnaList", name: "qnaList", component: QnaList, meta: { requiresAuth: true } },

    { path: "/statistics", name: "statistics", component: Statistics, meta: { requiresAuth: true } },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});

router.beforeEach((to, from, next) => {
    const user = userStore();
    const isLoggedIn = user !== null && user.accessToken;

    if (!isLoggedIn && to.name !== "Login") {
        next({ name: "Login" });
    } else {
        next();
    }
});

export default router;
